import { useEffect, useState } from "react";
import { Sun, Moon } from "@phosphor-icons/react";
import { getStoredTheme, setTheme } from "@/lib/theme";

export default function ThemeToggle() {
  const [theme, setLocal] = useState(getStoredTheme());

  useEffect(() => {
    setTheme(theme);
  }, [theme]);

  const isLight = theme === "light";

  return (
    <button
      data-testid="theme-toggle-btn"
      onClick={() => setLocal(isLight ? "dark" : "light")}
      className="theme-toggle inline-flex items-center gap-2 px-3 py-1.5 text-xs font-mono uppercase tracking-wider border transition-colors"
      title={isLight ? "Switch to dark mode" : "Switch to light mode"}
      aria-label="Toggle color theme"
    >
      {isLight ? <Moon size={14} weight="bold" /> : <Sun size={14} weight="bold" />}
      <span>{isLight ? "Dark" : "Light"}</span>
    </button>
  );
}
